import {DetailPanel} from '../../../../components/detailLayout';
import React, {useCallback, useState} from "react";
import {InspectionReportFieldControl} from "./InspectionReportFieldControl";
import {InspectionReportEditModal} from "./InspectionReportEditModal";
import {InspectionReportLegend} from "./InspectionReportCellStatus";
import "./inspectionReportMatrix.css";

function isFilled(value) {
    return value !== undefined && value !== null && value !== "";
}

function InspectionReportItem({view, obj, status, setter}) {
    const readOnly = status === "view";
    const [bulkGroupName, setBulkGroupName] = useState(null);

    const handleReportViewInputChange = useCallback((value, groupName, codeId) => {
        setter((prev) => {
            if (!prev?.reportView) return prev;

            return {
                ...prev,
                reportView: prev.reportView.map((group) => {
                    if (group.groupName !== groupName) return group;

                    const child = group.child ?? [];
                    const exists = child.some((item) => item.codeId === codeId);

                    return {
                        ...group,
                        child: exists
                            ? child.map((item) =>
                                item.codeId === codeId ? {...item, value} : item
                            )
                            : [...child, {codeId, value}],
                    };
                }),
            };
        });
    }, [setter]);

    const getItemValue = (group, codeId) =>
        group.child?.find((e) => e.codeId === codeId)?.value;

    const renderBulkModal = (group, items) => {
        if (readOnly || bulkGroupName !== group.groupName) return null;

        const filled = items.filter((item) => isFilled(getItemValue(group, item.id))).length;

        return (
            <InspectionReportEditModal
                open
                onClose={() => setBulkGroupName(null)}
                title={group.groupName}
                meta={`입력 ${filled}/${items.length}`}
                size="lg"
                hideHeaderBorder
            >
                <div className="ir-item-modal__form-scroll">
                    <table className="w-full asset-detail-kv-table ir-asset-modal__form">
                        <colgroup>
                            <col style={{width: "32%"}} />
                            <col style={{width: "68%"}} />
                        </colgroup>
                        <tbody>
                            {items.map((item, index) => (
                                <tr
                                    key={item.id ?? index}
                                    className={parseInt(item.type, 10) !== 1 ? "asset-detail-kv-row--auto" : ""}
                                >
                                    <th className="fieldset-th">{item.name}</th>
                                    <td className="fieldset-td">
                                        <InspectionReportFieldControl
                                            type={item.type}
                                            value={getItemValue(group, item.id)}
                                            onChange={(v) =>
                                                handleReportViewInputChange(v, group.groupName, item.id)
                                            }
                                            name={item.name}
                                            variant="modal"
                                            multiline={parseInt(item.type, 10) !== 1}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </InspectionReportEditModal>
        );
    };

    return (
        <>
            {!view && obj?.reportView?.length > 0 &&
                obj.reportView.map((group, groupIndex) => {
                    const items = obj.inspectionReportCode?.children?.filter(
                        (item) => item.groupName === group.groupName
                    ) ?? [];

                    const filledCount = items.filter((each) =>
                        isFilled(getItemValue(group, each.id))
                    ).length;

                    return (
                        <DetailPanel
                            key={group.groupName ?? groupIndex}
                            title={group.groupName}
                            className="inspection-report-section-panel"
                        >
                            <div className="ir-section-toolbar">
                                <div className="ir-section-toolbar__left">
                                    <span className="ir-section-stat">
                                        <strong>{items.length}</strong> 점검항목
                                    </span>
                                    <span className="ir-section-stat ir-section-stat--progress">
                                        입력 <strong>{filledCount}/{items.length}</strong>
                                    </span>
                                </div>
                            </div>

                            <InspectionReportLegend
                                actions={!readOnly && items.length > 0 && (
                                    <button
                                        type="button"
                                        className="ir-section-btn ir-section-btn--primary"
                                        onClick={() => setBulkGroupName(group.groupName)}
                                    >
                                        점검별 입력
                                    </button>
                                )}
                            />

                            <div className="ir-group-inline-form">
                                <table className="w-full asset-detail-kv-table ir-item-inline-form">
                                    <colgroup>
                                        <col style={{width: "32%"}} />
                                        <col style={{width: "68%"}} />
                                    </colgroup>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr
                                                key={item.id ?? index}
                                                className={parseInt(item.type, 10) !== 1 ? "ir-item-row--text" : ""}
                                            >
                                                <th className="fieldset-th">
                                                    <span className="ir-item-inline-form__name">{item.name}</span>
                                                    {item.etc && (
                                                        <span className="ir-item-inline-form__etc">{item.etc}</span>
                                                    )}
                                                </th>
                                                <td className="fieldset-td">
                                                    <InspectionReportFieldControl
                                                        type={item.type}
                                                        value={getItemValue(group, item.id)}
                                                        onChange={(v) =>
                                                            handleReportViewInputChange(v, group.groupName, item.id)
                                                        }
                                                        name={item.name}
                                                        readOnly={readOnly}
                                                        multiline={parseInt(item.type, 10) !== 1}
                                                        variant="inline"
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {renderBulkModal(group, items)}
                        </DetailPanel>
                    );
                })
            }
        </>
    );
}

export default InspectionReportItem;
